import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

const enableStripeSubscriptionAutoRenewal = async (subscriptionId: string): Promise<ApiResponse<void>> => {
  try {
    await paymentGatewayApi.put(
      `/v1/subscriptions/renew/${subscriptionId}`,
      undefined,
      { requireAuth: true }
    );
    return { data: null, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/subscriptions/renew/:id", method: "PUT", subscriptionId };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error enabling auto-renewal" };
  }
};

export default enableStripeSubscriptionAutoRenewal;
